import React, { useEffect, useState } from "react"
import DynamicImage from "@/components/core/Image/DynamicImage"
import noImage from "@/public/images/image-missing.png"
import { getConfig, initConfig } from "@/constants/config"
import { IS_IMAGE_PREFIX_REGEX } from "@/constants/regex"
import { getManualSmartCropBaseUrl } from "@/components/core/Image/manualSmartCrop"

const Image = props => {
  const {
    data: {
      id: uniqueId = "",
      alt = "",
      src: imgUrl = "",
      imageComponentProperties = {
        src: "",
        alt: "",
      },
      enableManualSmartCrop = false,
      items = [],
      smartCrops = [],
      defaultImageURL = "",
      imageURLWithoutCrop = "",
      imageServerUrl = "",
      assetID = "",
      defaultRenditions = "",
      imageModifiersScene7 = "",
      enableNoImage = false,
    } = {},
  } = props

  const IS_IMAGE_PREFIX = "/is/image/"
  const [resolvedImgUrl, setResolvedImgUrl] = useState("")
  const manualSmartCropItems = items.length ? items : smartCrops
  const manualSmartCropBaseUrl = getManualSmartCropBaseUrl({
    imageURLWithoutCrop,
    defaultImageURL,
    imageServerUrl,
    assetID,
    fileReference: resolvedImgUrl,
  })

  useEffect(() => {
    const resolve = async () => {
      if (imgUrl) {
        setResolvedImgUrl(imgUrl)
        return
      }
      const src = imageComponentProperties.src
      if (typeof src === "string" && src.startsWith(IS_IMAGE_PREFIX)) {
        await initConfig()
        const config = await getConfig()
        let swatchUrl = config?.general?.swatchUrl
        swatchUrl = swatchUrl.replace(IS_IMAGE_PREFIX_REGEX, IS_IMAGE_PREFIX)
        const imagePath = src.replace(IS_IMAGE_PREFIX, "")
        setResolvedImgUrl(swatchUrl + imagePath)
      } else {
        setResolvedImgUrl(src)
      }
    }
    resolve()
  }, [imgUrl, imageComponentProperties.src])

  return (
    <div className="image">
      <div className="eaem-bounding-div">
        <div className="cmp-image">
          {!enableNoImage ? (
            <DynamicImage
              {...{
                uniqueId,
                imgUrl: resolvedImgUrl,
                alt: alt || imageComponentProperties.alt,
                className: "cmp-image__image transition",
                enableManualSmartCrop,
                smartCropItems: manualSmartCropItems,
                manualSmartCropBaseUrl,
                defaultImageURL,
                defaultRendition: defaultRenditions,
                imageModifiersScene7,
              }}
            />
          ) : (
            <img src={noImage?.src} alt="coming soon" className="no-image" />
          )}
        </div>
      </div>
    </div>
  )
}

export default Image
